<template>
  <footer class="performance-card__meter-footer">
    <span class="performance-card__meter-footer-text" :class="getFooterClasses(performanceTypes, index)" v-for="(type, index) in performanceTypes" :key="index">{{type}}</span>
  </footer>
</template>

<script>
export default {
  props: {
    performanceTypes: {
      type: Array,
      required: true
    },
    getFooterClasses: {
      type: Function,
      required: true
    }
  }
}
</script>

<style>
  .performance-card__meter-footer {
    display: flex;
    font-weight: 500;
    font-size: 12px;
    text-align: left;
    line-height: 140%;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #778699;
  }

  .meter-text--first {
    text-align: left;
  }

  .meter-text--second {
    text-align: justify;
  }

  .meter-text--last {
    text-align: right;
  }

</style>
